<template>
  <div class="h5-container">
    <!-- 登录主体区域 -->
    <div class="login-wrapper">
      <!-- 新增：logo + 标题容器 -->
      <div class="title-logo-container">
        <!-- logo图片 -->
        <img
            src="@/assets/img/h5/login2.png"
        alt="球杆售后系统logo"
        class="system-logo"
        >
        <!-- 系统标题 -->
        <div class="system-title">球杆售后系统</div>
      </div>

      <!-- 登录表单 -->
      <van-form @submit="onSubmit" class="login-form">
        <!-- 手机号输入框 -->
        <van-field
            v-model="formData.phoneNumber"
            name="phoneNumber"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
            :rules="[{ required: true }, { pattern: mobileReg, message: '请输入正确的手机号' }]"
            clearable
        />

        <!-- 验证码输入框 + 获取验证码按钮 -->
        <van-field
            v-model="formData.code"
            name="code"
            label="验证码"
            placeholder="请输入6位验证码"
            :rules="[{ required: true}, { len: 6, message: '验证码为6位数字' }]"
            clearable
        >
          <template #button>
            <van-button
                size="small"
                type="info"
                :disabled="countDown > 0 || !isMobileValid"
                @click="getVerifyCode"
                class="code-btn"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </van-button>
          </template>
        </van-field>

        <!-- 登录按钮容器 -->
        <div class="login-btn-wrap">
          <van-button
              type="info"
              round
              block
              native-type="submit"
              class="login-btn"
              :loading="isLoading"
          >
            登录
          </van-button>
          <!-- 新球杆激活超链接 -->
          <router-link to="/activate_cue" class="activate-link">
            球杆激活
          </router-link>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import {memberLogin, sendCode} from "@/api/sales";
import {mapActions} from "vuex";

export default {
  name: "LoginPage",
  data() {
    return {
      // 表单数据
      formData: {
        phoneNumber: "", // 手机号
        code: ""    // 验证码
      },
      // 状态管理
      countDown: 0, // 验证码倒计时
      isLoading: false, // 登录按钮加载状态
      mobileReg: /^1[3-9]\d{9}$/, // 手机号正则
      timer: null // 倒计时定时器（防止内存泄漏）
    };
  },
  computed: {
    // 判断手机号是否合法
    isMobileValid() {
      return this.mobileReg.test(this.formData.phoneNumber);
    }
  },
  methods: {

    //提示语
    showDialogMsg(message){
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },
    ...mapActions(['setToken']), // 映射setToken方法
    // 获取验证码
    async getVerifyCode() {
      if (!this.isMobileValid) {
        Toast("请输入正确的手机号");
        return;
      }
      try {
        const res = await sendCode(this.formData.phoneNumber,'login')
        if (res.code === 200) {
          Toast("验证码已发送，请注意查收");
          this.countDown = 60
          this.timer = setInterval(() => {
            this.countDown--
            if (this.countDown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 500)
        } else {
          this.showDialogMsg(res.returnMsg);
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      }
    },
    // 登录提交
    async onSubmit() {
      this.isLoading = true
      try {
        const loginParams = {
          phoneNumber: this.formData.phoneNumber,
          captcha: this.formData.code
        }
        const res = await memberLogin(loginParams);
        if (res.code === 200) {
          this.setToken(res.token)
          this.$router.replace('/app_home')
        } else {
          Toast(res.returnMsg);
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      } finally {
        this.isLoading = false
      }
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
// 全局容器 - 移除所有背景图相关样式，恢复纯深色背景
.h5-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  box-sizing: border-box;
  > * {
    position: relative;
    z-index: 1;
  }
}

// 登录主体包裹层
.login-wrapper {
  width: 100%;
  max-width: 400px; // 限制最大宽度，适配平板
}

// logo + 标题容器
.title-logo-container {
  display: flex;
  flex-direction: column;
  align-items: center; // 水平居中
  margin-bottom: 20px; // 保持和原标题一致的底部间距
}

// logo样式
.system-logo {
  width: 100%; // logo宽度（可根据实际图片调整）
  object-fit: contain; // 等比例缩放，不拉伸变形
  margin-bottom: 16px; // logo和标题的间距
}

// 系统标题
.system-title {
  font-size: 24px;
  font-weight: bold;
  color: #D4AF37; // 金色主题色
  text-align: center;
  letter-spacing: 2px;
  // 移除原标题的margin-bottom，改为容器统一控制
  margin-bottom: 0;
}

// 登录表单
.login-form {
  background: rgba(26, 26, 26, 0.7);
  padding: 24px;
  border-radius: 12px;
  box-sizing: border-box;
  width: 100%;
}

// 验证码按钮
.code-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: 500;
}

// 登录按钮容器
.login-btn-wrap {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .activate-link {
    align-self: flex-end;
    color: #D4AF37;
    font-size: 14px;
    text-decoration: none;
    max-width: 100%;
    &:hover {
      color: #B8860B;
      text-decoration: underline;
    }
  }
}

// 登录按钮
.login-btn {
  height: 48px;
  font-size: 16px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: bold;
  width: 100%;
}

// 适配Vant组件样式
::v-deep .van-field__label{
  width: 50px;
}
::v-deep .van-field {
  --van-field-label-color: #fff;
  --van-field-input-color: #fff;
  --van-field-placeholder-color: #999;
  --van-field-border-color: rgba(212, 175, 55, 0.2);
  margin-bottom: 16px;
  border-radius: 10px;
  box-sizing: border-box;
}

::v-deep .van-button--info {
  --van-button-info-background: #D4AF37;
  --van-button-info-border-color: #D4AF37;
}
</style>